package com.exura.features.legacyplans.di

import com.exura.features.legacyplans.data.repository.BaseDetailedPlanRepositoryImpl
import com.exura.features.legacyplans.data.repository.DetailedPlanRepositoryImpl
import com.exura.features.legacyplans.domain.repository.BaseDetailedPlanRepository
import com.exura.features.legacyplans.domain.repository.DetailedPlanRepository
import com.exura.features.legacyplans.domain.usecase.DistributeDetailedPlanViaReceiverIdUseCase
import com.exura.features.legacyplans.domain.usecase.SaveDetailedPlanUseCase
import org.koin.dsl.module

val legacyPlansModule = module {
    single<BaseDetailedPlanRepository> {
        BaseDetailedPlanRepositoryImpl(
            firestore = get(),
        )
    }

    single<DetailedPlanRepository> {
        DetailedPlanRepositoryImpl(
            baseRepository = get(),
            getUserDataPrefixUseCase = get(),
        )
    }

    factory<SaveDetailedPlanUseCase> { SaveDetailedPlanUseCase(get()) }
    factory<DistributeDetailedPlanViaReceiverIdUseCase> { DistributeDetailedPlanViaReceiverIdUseCase(get()) }
}
